import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome';

export default function LatestComments() {
  const { allWpComment } = useStaticQuery(graphql`
    {
      allWpComment(limit: 12, sort: {order: DESC, fields: date}) {
        edges {
          node {
            id
            author {
              node {
                name
                url
              }
            }
            commentedOn {
              node {
                uri
                ... on WpPage {
                  title
                }
                ... on WpPost {
                  title
                }
              }
            }
          }
        }
      }
    }
  `);

  const comments = allWpComment.edges;

  return (    
    <article id="latest-posts" className="post-preview" style={{boxShadow: 'none'}}>
      <header>        
        <h3><FontAwesomeIcon icon="comments" style={{marginRight: '.5em'}} />Neuste Kommentare</h3>
        <hr noshade/>
      </header>
      <section>
        <ul>
        {comments.map(({node}) => {     
          const post = node.commentedOn.node;
          const author = node.author.node;

          return (
            <li key={node.id}>
              { 
                author?.url 
                ? <a href={author?.url} target="_blank" rel="noreferrer" external="true" dangerouslySetInnerHTML={{ __html: author.name }} />
                : author.name
              }              
							{post && <>{' bei '}<Link to={post.uri} aria-label={post.title} dangerouslySetInnerHTML={{ __html: post.title }} /></> }
            </li>
          );
        })}
        </ul>
      </section>
    </article>    
  );
}